import { render, staticRenderFns } from "./BasePhoneNumber.vue?vue&type=template&id=46433f23"
import script from "./BasePhoneNumber.vue?vue&type=script&lang=js"
export * from "./BasePhoneNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports